<template>
  <div>
    <van-tabs class="custom">
      <van-tab title="活动详情">
        <div class="global--rich" v-html="rich" />
      </van-tab>
      <van-tab title="直播动态">
        <more-dynamic :list="lives" />
      </van-tab>
      <van-tab title="相册">
        <more-photo :list="album" />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import MoreDynamic from './MoreDynamic'
import MorePhoto from './MorePhoto'

export default {
  components: {
    MoreDynamic,
    MorePhoto
  },
  props: {
    rich: {
      type: String,
      default: ''
    },
    lives: {
      type: Array,
      default() {
        return []
      }
    },
    album: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>
